import React, { useState, useEffect } from 'react';
import Modal from '../Modal.js';
import Button from '../Button.js';
import FormInput from '../FormInput.js';

const BranchDialog = ({
  isOpen,
  onClose,
  onSave,
  branch = null,
  loading = false
}) => {
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    manager: '',
    managerPhone: '',
    tokenPapers: 1,
    state: 'Active'
  });
  const [errors, setErrors] = useState({});

  const isEditing = !!branch;

  useEffect(() => {
    if (branch) {
      setFormData({
        name: branch.name || '',
        location: branch.location || '',
        manager: branch.manager || '',
        managerPhone: branch.managerPhone || '',
        tokenPapers: branch.tokenPapers || 1,
        state: branch.state || 'Active'
      });
    } else {
      setFormData({
        name: '',
        location: '',
        manager: '',
        managerPhone: '',
        tokenPapers: 1,
        state: 'Active'
      });
    }
    setErrors({});
  }, [branch, isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Branch name is required';
    }

    if (!formData.location.trim()) {
      newErrors.location = 'Branch location is required';
    }

    // Manager and phone are optional
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    onSave(formData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditing ? 'Edit Branch' : 'Create New Branch'}
      size="medium"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <FormInput
          id="name"
          name="name"
          label="Branch Name"
          placeholder="Enter branch name"
          value={formData.name}
          onChange={handleInputChange}
          error={errors.name}
          required
        />

        <FormInput
          id="location"
          name="location"
          label="Location"
          placeholder="Enter branch location"
          value={formData.location}
          onChange={handleInputChange}
          error={errors.location}
          required
        />

        <FormInput
          id="manager"
          name="manager"
          label="Manager Email"
          type="email"
          placeholder="Enter manager email"
          value={formData.manager}
          onChange={handleInputChange}
          error={errors.manager}
        />

        <FormInput
          id="managerPhone"
          name="managerPhone"
          label="Manager Phone"
          type="tel"
          placeholder="Enter manager phone number"
          value={formData.managerPhone}
          onChange={handleInputChange}
          error={errors.managerPhone}
        />

        <FormInput
          id="tokenPapers"
          name="tokenPapers"
          label="Number of Token Papers"
          type="number"
          min="1"
          placeholder="Enter number of token papers (1-10)"
          value={formData.tokenPapers}
          onChange={handleInputChange}
          error={errors.tokenPapers}
          required
        />

        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">
            Status
          </label>
          <div className="flex gap-6">
            <label className="flex items-center">
              <input
                type="radio"
                name="state"
                value="Active"
                checked={formData.state === 'Active'}
                onChange={handleInputChange}
                className="text-blue-600 focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-700">Active</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="state"
                value="Inactive"
                checked={formData.state === 'Inactive'}
                onChange={handleInputChange}
                className="text-blue-600 focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-700">Inactive</span>
            </label>
          </div>
        </div>

        <Modal.Actions>
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={loading}
          >
            {isEditing ? 'Save Changes' : 'Create Branch'}
          </Button>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

export default BranchDialog;